/**
 * MltTags — компонент для MLT-полей (тэг-облако)
 *
 * Использование в HTML:
 * <div class="mlt-tags" data-mlt-field="mlt_psy_specializations" data-mlt-table="specializations">
 *   <div class="mlt-tags__list">...</div>
 *   <div class="mlt-tags__search">
 *     <input class="mlt-tags__search-input" />
 *     <div class="mlt-tags__dropdown">
 *       <div class="mlt-tags__dropdown-item" data-id="1">Название</div>
 *     </div>
 *   </div>
 * </div>
 */
var MltTags = {
	moduleId: null,

	/**
	 * Инициализация
	 */
	init: function() {
		var self = this;

		// Получаем moduleId из контейнера профиля
		var container = document.querySelector('[data-psy-profile-module-id]');
		if (container) {
			this.moduleId = container.dataset.psyProfileModuleId;
		}

		// Инициализируем все компоненты
		document.querySelectorAll('.mlt-tags').forEach(function(el) {
			self.initComponent(el);
		});
	},

	/**
	 * Инициализация одного компонента
	 */
	initComponent: function(container) {
		var self = this;
		var input = container.querySelector('.mlt-tags__search-input');
		var dropdown = container.querySelector('.mlt-tags__dropdown');

		if (!input || !dropdown) return;

		// Скрываем уже выбранные элементы в dropdown
		this.updateDropdownVisibility(container);

		// Изначально скрываем dropdown
		dropdown.style.display = 'none';

		// Фокус — показываем dropdown
		input.addEventListener('focus', function() {
			dropdown.style.display = 'block';
			self.filterDropdown(container, input.value);
		});

		// Ввод — фильтруем
		input.addEventListener('input', function() {
			self.filterDropdown(container, input.value);
		});

		// mousedown по элементу dropdown (раньше blur, надёжнее click)
		dropdown.addEventListener('mousedown', function(e) {
			var item = e.target.closest('.mlt-tags__dropdown-item');
			if (!item) return;
			e.preventDefault(); // не теряем фокус с input
			if (item.classList.contains('mlt-tags__dropdown-item--add')) {
				self.addNewTag(container, input.value.trim());
			} else {
				self.selectItem(container, item);
			}
		});

		// Enter — выбрать первый видимый или добавить новый
		input.addEventListener('keydown', function(e) {
			if (e.key === 'Enter') {
				e.preventDefault();
				var visible = dropdown.querySelector('.mlt-tags__dropdown-item:not([style*="display: none"]):not(.mlt-tags__dropdown-item--selected)');
				if (visible) {
					if (visible.classList.contains('mlt-tags__dropdown-item--add')) {
						self.addNewTag(container, input.value.trim());
					} else {
						self.selectItem(container, visible);
					}
				}
			}
		});

		// Закрытие по клику вне
		document.addEventListener('click', function(e) {
			if (!container.contains(e.target)) {
				dropdown.style.display = 'none';
			}
		});
	},

	/**
	 * Фильтрация dropdown по строке поиска
	 */
	filterDropdown: function(container, query) {
		var dropdown = container.querySelector('.mlt-tags__dropdown');
		var items = dropdown.querySelectorAll('.mlt-tags__dropdown-item:not(.mlt-tags__dropdown-item--add)');
		var selectedIds = this.getSelectedIds(container);
		var q = query.toLowerCase().trim();
		var hasMatch = false;
		var hasExact = false;

		items.forEach(function(item) {
			var id = parseInt(item.dataset.id);
			var text = item.textContent.toLowerCase();

			// Скрываем уже выбранные
			if (selectedIds.indexOf(id) !== -1) {
				item.style.display = 'none';
				item.classList.add('mlt-tags__dropdown-item--selected');
				return;
			}

			item.classList.remove('mlt-tags__dropdown-item--selected');

			// Фильтруем по тексту
			if (q === '' || text.indexOf(q) !== -1) {
				item.style.display = '';
				hasMatch = true;
				if (text === q) hasExact = true;
			} else {
				item.style.display = 'none';
			}
		});

		// Удаляем старую кнопку "добавить"
		var addBtn = dropdown.querySelector('.mlt-tags__dropdown-item--add');
		if (addBtn) addBtn.remove();

		// Добавляем кнопку "добавить" если нет точного совпадения и есть запрос
		if (q.length > 1 && !hasExact) {
			var btn = document.createElement('div');
			btn.className = 'mlt-tags__dropdown-item mlt-tags__dropdown-item--add';
			btn.textContent = '+ Добавить «' + query.trim() + '»';
			dropdown.appendChild(btn);
		}
	},

	/**
	 * Получить выбранные ID
	 */
	getSelectedIds: function(container) {
		var ids = [];
		container.querySelectorAll('.mlt-tags__hidden').forEach(function(input) {
			ids.push(parseInt(input.value));
		});
		return ids;
	},

	/**
	 * Выбрать элемент из dropdown
	 */
	selectItem: function(container, dropdownItem) {
		var id = dropdownItem.dataset.id;
		var name = dropdownItem.textContent.trim();
		var fieldName = container.dataset.mltField;
		var list = container.querySelector('.mlt-tags__list');
		var input = container.querySelector('.mlt-tags__search-input');

		// Создаём тэг
		this.createTag(list, fieldName, id, name);

		// Скрываем элемент в dropdown
		dropdownItem.style.display = 'none';
		dropdownItem.classList.add('mlt-tags__dropdown-item--selected');

		// Очищаем поле
		input.value = '';
		this.filterDropdown(container, '');
	},

	/**
	 * Создать DOM-элемент тэга
	 */
	createTag: function(list, fieldName, id, name) {
		if (list.querySelector('[data-tag-id="' + parseInt(id, 10) + '"]')) return;
		var tag = document.createElement('span');
		tag.className = 'mlt-tags__tag';
		tag.dataset.tagId = id;
		tag.innerHTML =
			'<span class="mlt-tags__tag-text">' + this.escapeHtml(name) + '</span>' +
			'<input type="hidden" name="' + fieldName + '[]" value="' + id + '" class="mlt-tags__hidden"/>' +
			'<button type="button" class="mlt-tags__tag-remove" onclick="MltTags.removeTag(this)">&times;</button>';
		list.appendChild(tag);
	},

	/**
	 * Удалить тэг
	 */
	removeTag: function(btn) {
		var tag = btn.closest('.mlt-tags__tag');
		var container = btn.closest('.mlt-tags');
		var tagId = tag.dataset.tagId;

		// Удаляем тэг
		tag.remove();

		// Показываем элемент в dropdown обратно
		if (container) {
			var dropdown = container.querySelector('.mlt-tags__dropdown');
			var item = dropdown.querySelector('.mlt-tags__dropdown-item[data-id="' + tagId + '"]');
			if (item) {
				item.style.display = '';
				item.classList.remove('mlt-tags__dropdown-item--selected');
			}
		}
	},

	/**
	 * Добавить новый тэг через AJAX
	 */
	addNewTag: function(container, name) {
		if (!name) return;
		var moduleId = container.dataset.mltModuleId || this.moduleId;
		if (!moduleId) {
			console.error('[MltTags] moduleId is not set');
			alert('Ошибка: не определён ID модуля');
			return;
		}

		var self = this;
		var tableName = container.dataset.mltTable;
		var fieldName = container.dataset.mltField;
		var list = container.querySelector('.mlt-tags__list');
		var dropdown = container.querySelector('.mlt-tags__dropdown');
		var input = container.querySelector('.mlt-tags__search-input');

		var formData = new FormData();
		formData.append('action', 'add_tag');
		formData.append('table', tableName);
		formData.append('name', name);
		if (container.dataset.mltCsrf) formData.append('csrf', container.dataset.mltCsrf);

		fetch('/ajax.php?mid=' + moduleId, {
			method: 'POST',
			body: formData
		})
		.then(function(r) { return r.text(); })
		.then(function(text) {
			var res;
			try { res = JSON.parse(text); } catch(e) {
				console.error('[MltTags] Invalid JSON:', text);
				alert('Ошибка сервера');
				return;
			}
			if (res.success) {
				var existingItem = dropdown.querySelector('.mlt-tags__dropdown-item[data-id="' + parseInt(res.id, 10) + '"]');
				if (existingItem) {
					self.selectItem(container, existingItem);
					return;
				}
				// Добавляем тэг
				self.createTag(list, fieldName, res.id, res.name || name);

				// Добавляем в dropdown (чтобы можно было удалить и снова добавить)
				var newItem = document.createElement('div');
				newItem.className = 'mlt-tags__dropdown-item mlt-tags__dropdown-item--selected';
				newItem.dataset.id = res.id;
				newItem.textContent = res.name || name;
				newItem.style.display = 'none';
				// Вставляем перед кнопкой "добавить"
				var addBtn = dropdown.querySelector('.mlt-tags__dropdown-item--add');
				if (addBtn) {
					dropdown.insertBefore(newItem, addBtn);
					addBtn.remove();
				} else {
					dropdown.appendChild(newItem);
				}

				// Очищаем
				input.value = '';
				self.filterDropdown(container, '');
			} else {
				alert(res.error || 'Ошибка добавления');
			}
		})
		.catch(function(err) {
			console.error('[MltTags] Network error:', err);
			alert('Ошибка сети');
		});
	},

	/**
	 * Обновить видимость уже выбранных в dropdown
	 */
	updateDropdownVisibility: function(container) {
		var selectedIds = this.getSelectedIds(container);
		var dropdown = container.querySelector('.mlt-tags__dropdown');

		dropdown.querySelectorAll('.mlt-tags__dropdown-item').forEach(function(item) {
			var id = parseInt(item.dataset.id);
			if (selectedIds.indexOf(id) !== -1) {
				item.style.display = 'none';
				item.classList.add('mlt-tags__dropdown-item--selected');
			}
		});
	},

	/**
	 * Экранирование HTML
	 */
	escapeHtml: function(str) {
		var div = document.createElement('div');
		div.textContent = str;
		return div.innerHTML;
	}
};

// Инициализация
$(document).ready(function() {
	MltTags.init();
});

window.MltTags = MltTags;
